













import { computed, defineComponent, PropType } from '@vue/composition-api';
import { StepContentTypeEnum } from '@front-app/api-generated/learning-management-api';
import SelectBox from '@front-app/components/inputs/SelectBox.vue';
import { useTranslate } from '@front-app/hooks/useTranslate';
import { NewLearningStepContentType } from '../Model';

const OPTIONS: NewLearningStepContentType[] = [
	'none',
	StepContentTypeEnum.Survey,
	StepContentTypeEnum.Youtube,
	StepContentTypeEnum.Vimeo,
];

const LABELS: Record<NewLearningStepContentType, string> = {
	none: 'none',
	[StepContentTypeEnum.Survey]: 'lms.admin.forms.step-type-choice-survey',
	[StepContentTypeEnum.Youtube]: 'lms.admin.forms.step-type-choice-youtube',
	[StepContentTypeEnum.Vimeo]: 'lms.admin.forms.step-type-choice-vimeo',
};

export default defineComponent({
	components: { SelectBox },
	props: {
		value: {
			type: String as PropType<NewLearningStepContentType>,
			required: true,
		},
	},
	setup(props, ctx) {
		const $t = useTranslate(ctx);
		const getLabelForKey = (key: NewLearningStepContentType): string => $t(LABELS[key]) as unknown as string;
		const selectOptions = computed(() => OPTIONS.map((key) => ({
			key,
			label: getLabelForKey(key),
		})));
		return {
			getLabelForKey,
			selectOptions,
		};
	},
});
